import { ref } from 'vue';

// Create a reactive notification store that can be shared across components
const notifications = ref([]);
let notificationId = 0;

export function useNotification() {
  // Show a notification
  const showNotification = (message, type = 'info', duration = 5000) => {
    const id = notificationId++;

    // Add notification to the array
    notifications.value.push({
      id,
      message,
      type, // 'info', 'success', 'warning', 'error'
      duration,
    });

    // Automatically remove notification after duration
    if (duration > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, duration);
    }

    return id;
  };

  // Remove a notification by id
  const removeNotification = (id) => {
    const index = notifications.value.findIndex((notification) => notification.id === id);
    if (index !== -1) {
      notifications.value.splice(index, 1);
    }
  };

  // Clear all notifications
  const clearNotifications = () => {
    notifications.value = [];
  };

  return {
    notifications,
    showNotification,
    removeNotification,
    clearNotifications,
  };
}
